import { ArrowRight, ExternalLink } from "lucide-react"
import { PrimaryBtn } from "../../../common/ui/buttons"

interface ApiMarketingCtaProps {
  mailtoHref: string
}

export const ApiMarketingCta = ({ mailtoHref }: ApiMarketingCtaProps) => (
  <div className="text-center space-y-4">
    <PrimaryBtn
      target="_self"
      href={mailtoHref}
      className="px-8 py-3 text-base font-semibold"
    >
      Enable API Access
      <ArrowRight size={18} className="ml-2" />
    </PrimaryBtn>

    <div>
      <a
        href="https://bbrid.ge/swagger"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2 text-neutral-600 hover:text-primary-600 transition-colors text-base font-medium"
      >
        View documentation
        <ExternalLink size={16} />
      </a>
    </div>
  </div>
)
